import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { PhxTableColumnConfig, PhxTableColumnCustomizerItem } from '../phx-table.types';
import { Eye, EyeDisabled } from '../../icon/icon-map';

@Component({
  selector: 'phx-table-column-customizer',
  templateUrl: './phx-table-column-customizer.component.html',
  styleUrls: ['./phx-table-column-customizer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class PhxTableColumnCustomizerComponent implements OnChanges {
  /** Whether the column customizer modal is open (two-way bindable). */
  @Input() phxOpen = false;
  /** Full column configuration; visibility toggles are applied on save. */
  @Input() phxColumnsConfig: PhxTableColumnConfig[] = [];

  /** Emitted when the modal open state changes. */
  @Output() phxOpenChange = new EventEmitter<boolean>();
  /** Emitted when the user applies a new column visibility configuration. */
  @Output() phxColumnsConfigChange = new EventEmitter<PhxTableColumnConfig[]>();

  public readonly EyeIcon = Eye;
  public readonly EyeDisabledIcon = EyeDisabled;

  public items: PhxTableColumnCustomizerItem[] = [];

  constructor(private _cdr: ChangeDetectorRef) {}

  public ngOnChanges(): void {
    if (this.phxOpen) {
      this.buildItems();
    }
  }

  public onToggleVisibility(item: PhxTableColumnCustomizerItem): void {
    item.visible = !item.visible;
    this._cdr.markForCheck();
  }

  public onApply(): void {
    const configMap = new Map<string, PhxTableColumnConfig>();
    for (const col of this.phxColumnsConfig) {
      configMap.set(col.key, col);
    }

    const result = this.items.map(item => {
      const col = configMap.get(item.key)!;
      return { ...col, visible: item.visible ? undefined : false };
    });

    this.phxColumnsConfigChange.emit(result);
    this.close();
  }

  public onCancel(): void {
    this.close();
  }

  private close(): void {
    this.phxOpen = false;
    this.phxOpenChange.emit(false);
  }

  private buildItems(): void {
    this.items = this.phxColumnsConfig.map(col => ({
      key: col.key,
      label: this.getColumnLabel(col),
      visible: col.visible !== false,
    }));
  }

  private getColumnLabel(col: PhxTableColumnConfig): string {
    const config = col.headerConfig;
    if (!config) return col.key;
    if (Array.isArray(config)) return config.map(h => h.label).join(' / ');
    return config.label || col.key;
  }
}
